import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { ArrowLeft } from 'lucide-react';

const LegalLayout = ({ title, lastUpdated, children, canonical, description }) => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-black text-white pt-24 pb-24" data-testid="legal-page">
      <Helmet>
        <title>{`${title} | Aryan Shivhare`}</title>
        <meta name="description" content={description || `${title} for aryanshivhare.com`} />
        {canonical && <link rel="canonical" href={canonical} />}
        <meta property="og:title" content={`${title} | Aryan Shivhare`} />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="max-w-3xl mx-auto px-6 lg:px-12">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-sm text-tertiary hover:text-gold transition-colors font-sans mb-10"
          data-testid="legal-back-button"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to home
        </button>

        <h1 className="font-serif text-4xl lg:text-5xl text-gold mb-3" data-testid="legal-title">
          {title}
        </h1>
        <p className="text-sm text-tertiary font-sans mb-12">Last updated: {lastUpdated}</p>

        <div className="legal-content space-y-8 text-secondary font-sans text-base leading-relaxed">
          {children}
        </div>
      </div>
    </div>
  );
};

export const LegalSection = ({ heading, children }) => (
  <section className="space-y-3">
    <h2 className="font-serif text-2xl text-white">{heading}</h2>
    {children}
  </section>
);

export default LegalLayout;
